export default "__VITE_ASSET__DLuUb5T1__"